import { Component, Input, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { LOCAL_STORAGE_UTILS } from '@monorepo/utils';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ui-default-error-modal',
  templateUrl: './default-error-modal.component.html',
  styleUrls: ['./default-error-modal.component.scss'],
})
export class DefaultErrorModalComponent implements OnInit {
  @Input() errorTxt = '';
  @Input() enableAlarm = false;
  alarm: HTMLAudioElement = new Audio('/assets/common/mm_notif_sound.wav');

  constructor(private modalCtrl: ModalController, private navParams: NavParams) {}

  ngOnInit(): void {
    this.errorTxt = this.errorTxt || this.navParams.get('errorTxt');
    const isAlarmEnabled = LOCAL_STORAGE_UTILS.retrieveData('alarmSignal');
    if (isAlarmEnabled === 'enabled' || this.enableAlarm) {
      this.alarm.loop = true;
      this.alarm.play();
    }
  }

  dismissModal() {
    this.modalCtrl.dismiss();
    console.log('alert dismissed');
    this.alarm.pause();
    this.alarm.currentTime = 0;
  }
}
